import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FormattedPriceComponent } from './components/formatted-price/formatted-price.component';
import { ProductPriceService } from './services/product-prices.service';

@NgModule({
    imports: [
        CommonModule,
        FormattedPriceComponent,
        TranslateModule.forChild(),
    ],
    exports: [FormattedPriceComponent],
    providers: [
        ProductPriceService,
    ],
})
export class PricesModule {}
